module.exports = __webpack_public_path__ + "assets/dotdigital.66932962.svg";